import React, { useEffect, useRef } from "react";
import styles from "./comp_css/chapter_37.module.css";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import Head from "next/head";
import BlockData from "../../../central-doctraine-json/chapter37.json";
import Common_html from "./Common_html";

export default function Chapter_37() {
  //   const corosalref = useRef()

  //   useEffect(()=>{
  //     if(corosalref.current)
  //     {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent",corosalref.current);
  // },[corosalref.current])

  const router = useRouter()
  const location = useRouter();
  const { pathname } = location;


  return (
    <>
      <Head>
        <title>THE CONSCIOUS SOLAR SYSTEM | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Divine Infinite Being, Central Doctrine, Chapter-XXXVIII"
        ></meta>
        <meta
          property="og:title"
          content="THE CONSCIOUS SOLAR SYSTEM | School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta property="og:image:alt" content="An imaginative depiction of a solar system infused with consciousness, where celestial bodies are interconnected through luminous threads of awareness. The image symbolizes the integration of cosmic elements with conscious presence, highlighting the idea of a sentient and interconnected solar system."></meta>
        <meta
          property="og:description"
          content="Explore the Central Doctrine of The Conscious Solar System, where the cosmos is viewed as an interconnected network of conscious entities. Discover how celestial bodies and cosmic phenomena are linked through a web of awareness, revealing a profound and sentient understanding of our solar system."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=37"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"></meta>
        <meta property="twitter:image:alt" content="An imaginative depiction of a solar system infused with consciousness, where celestial bodies are interconnected through luminous threads of awareness. The image symbolizes the integration of cosmic elements with conscious presence, highlighting the idea of a sentient and interconnected solar system."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=37"></meta>
        <meta name="twitter:title" content="THE CONSCIOUS SOLAR SYSTEM | School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="Explore the Central Doctrine of The Conscious Solar System, where the cosmos is viewed as an interconnected network of conscious entities. Discover how celestial bodies and cosmic phenomena are linked through a web of awareness, revealing a profound and sentient understanding of our solar system."></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=37" />
      </Head>


      <Common_html BlockData={BlockData} />
    </>
  );
}
